import { render, staticRenderFns } from "./ValveDetail.vue?vue&type=template&id=9fbb76c8&scoped=true"
import script from "./ValveDetail.vue?vue&type=script&lang=js"
export * from "./ValveDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fbb76c8",
  null
  
)

export default component.exports